import React from 'react';
import CustomDeletePage from 'components/custom-pages/CustomDelete';

const Delete = ({ data, handleClick }) => {
  return (
    <CustomDeletePage
      pageTitle={'Delete Vehicle Model'}
      url={'vehicle-model-master'}
      queryKey="vehicle-model-master"
      title={'Vehicle Model'}
      id={data?._id}
      handleClick={handleClick}
    />
  );
};

export default Delete;
